import React, { useState } from "react";
import { useNavigate, useParams } from "react-router";
import { getBlogDetailsFromSlug } from "../services/writerBlog";

const RecentPosts = (props) => {
  const navigate = useNavigate();

  return (
    <div className="blog-category-box mt-4">
      <div className="heading-box">
        <h2>Recent Posts</h2>
        <p>All the latest posts</p>
      </div>
      <ul>
        {props.recentPosts.map((post) => (
          <li
            key={post._id}
            style={{ cursor: "pointer" }}
            onClick={() => navigate(`/blog/${post.slug}`)}
          >
            {post.title}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RecentPosts;
